import Notes from './Notes'

export default Notes
